/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {UserListRequest} from '../models/UserListRequest';
import type {UserListResponse} from '../models/UserListResponse';
import type {UserStateCriteria} from '../models/UserStateCriteria';

export interface DownloadUserListReport$Request {
    userListRequest: UserListRequest;
}

export interface DownloadUserListReport$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const downloadUserListReportRequest = createAction<PayloadData<void, DownloadUserListReport$Request>>('USER_LIST_REPORT__DOWNLOAD_USER_LIST_REPORT__REQUEST');
export const downloadUserListReportSuccess = createAction<PayloadData<Array<UserListResponse>, DownloadUserListReport$Request>>('USER_LIST_REPORT__DOWNLOAD_USER_LIST_REPORT__SUCCESS');
export const downloadUserListReportFailure = createAction<PayloadData<Error, DownloadUserListReport$Request, true>>('USER_LIST_REPORT__DOWNLOAD_USER_LIST_REPORT__FAILURE');

export const downloadUserListReportActions = [
    downloadUserListReportRequest,
    downloadUserListReportSuccess,
    downloadUserListReportFailure
] as const;

/**
 * @param {UserListRequest} meta.userListRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const downloadUserListReport = (meta: DownloadUserListReport$Request, config?: DownloadUserListReport$Config) => {
    return {
        CALL_API: {
            types: downloadUserListReportActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/reports/user-list`,
            TRANSPORT_REQUEST_BODY: meta.userListRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetUserListIds$Request {
    accountId: number;
    states: Array<UserStateCriteria>;
    groupId?: number;
}

export interface GetUserListIds$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getUserListIdsRequest = createAction<PayloadData<void, GetUserListIds$Request>>('USER_LIST_REPORT__GET_USER_LIST_IDS__REQUEST');
export const getUserListIdsSuccess = createAction<PayloadData<Array<number>, GetUserListIds$Request>>('USER_LIST_REPORT__GET_USER_LIST_IDS__SUCCESS');
export const getUserListIdsFailure = createAction<PayloadData<Error, GetUserListIds$Request, true>>('USER_LIST_REPORT__GET_USER_LIST_IDS__FAILURE');

export const getUserListIdsActions = [
    getUserListIdsRequest,
    getUserListIdsSuccess,
    getUserListIdsFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {Array<UserStateCriteria>} meta.states
 * @param {number} [meta.groupId]
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getUserListIds = (meta: GetUserListIds$Request, config?: GetUserListIds$Config) => {
    const TRANSPORT_GET_PARAMS = {
        accountId: meta.accountId,
        states: meta.states,
        groupId: meta.groupId,
    };
    return {
        CALL_API: {
            types: getUserListIdsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/reports/user-list`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

